<section class="research-viewer">
  <ng-container *ngIf="isLoading">
    <ul nz-menu class="note-skeleton">
      <li
        *ngFor="
          let dummySection of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]
        "
        style="padding: 0px 15px 0px 15px"
      >
        <nz-skeleton
          [nzTitle]="true"
          [nzActive]="true"
          [nzParagraph]="false"
        ></nz-skeleton>
      </li>
    </ul>
  </ng-container>
  <ng-container *ngIf="!isLoading">
    <div class="zoom-buttons" *ngIf="documentType === 'pdf'">
      <button class="zoom-out" (click)="onZoomOut()">
        <va-icon isFontAwesome="true" [name]="faSearchMinus"></va-icon>
      </button>

      <button class="zoom-in" (click)="onZoomIn()">
        <va-icon isFontAwesome="true" [name]="faSearchPlus"></va-icon>
      </button>
    </div>
  </ng-container>

  <div
    id="pdfViewerContainer"
    class="pdf-viewer-container"
    *ngIf="documentType === 'pdf'"
  >
    <div id="viewerContainer">
      <div id="viewer" class="pdfViewer"></div>
    </div>
  </div>

  <div
    class="file-viewer-container"
    *ngIf="documentType === 'linkback' && fileUrl !== ''"
  >
    <!-- uncomment below for local testing, and comment next iframe  -->
    <!-- <iframe name="linkback-iframe" class="linkback-frame" src="http://localhost:4200/"></iframe> -->
    <iframe name="linkback-iframe" class="linkback-frame"></iframe>
    <form action="" method="post" target="linkback-iframe" id="linkbackIframe">
      <input type="hidden" name="SAMLResponse" id="SAMLResponse" value="" />
      <input type="hidden" name="RelayState" id="RelayState" value="" />
    </form>
  </div>
  <div
    class="file-viewer-container"
    *ngIf="documentType != 'pdf' && documentType != 'linkback'"
  >
    <div class="document-title">
      <span>{{ documentTitle }}</span>
    </div>
    <div class="document-summary">
      <span>{{ documentSummary }}</span>
    </div>
    <div class="view-button-container">
      <button
        *ngIf="documentType == 'html'"
        id="documentViewer"
        nz-button
        nzType="primary"
        (click)="viewHtmlDoc()"
      >
        View Document
      </button>
      <button
        nz-button
        id="documentViewer"
        *ngIf="
          documentType &&
          documentType != 'html' &&
          documentType != 'linkback' &&
          documentType != 'pdf' &&
          documentType != ''
        "
        (click)="downloadDocument()"
        nzType="primary"
      >
        <span>Download Document</span>
      </button>
    </div>
  </div>
</section>
